import { I18n } from "../services/I18n";
import "./generated/site-translations-uk";
import common_uk from "../../../../../libs/ps/restaumatic-common/locales/uk.json";
import core_types_sites_uk from "../../../../../libs/ps/restaumatic-core-types-sites/locales/uk.json";
I18n.translations = I18n.translations || {};
I18n.translations = I18n.extend(I18n.translations, {
  uk: { _core_types_sites: core_types_sites_uk },
});
I18n.translations = I18n.extend(I18n.translations, {
  uk: { _common: common_uk },
});
